import { InjectionToken } from '@angular/core';

export const INTERESTING_LOTS_KEY = 'akebono-interesting-lots';
export const INTERESTING_CHANGE = 'akebono-interesting-lots-change';
export const INTERESTING_LIMIT = new InjectionToken<string>('akebono-interesting-lots-limit');
export const INTERESTING_LIMIT_DEFAULT = 500;
